"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HistoryManager_currentStateIndex, _HistoryManager_drawingToolsManager, _HistoryManager_history;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryManager = void 0;
const viewer_1 = require("@shapediver/viewer");
// #endregion Type aliases (1)
// #region Classes (1)
class HistoryManager {
    // #endregion Properties (3)
    // #region Constructors (1)
    constructor(drawingToolsManager) {
        // #region Properties (3)
        _HistoryManager_currentStateIndex.set(this, -1);
        _HistoryManager_drawingToolsManager.set(this, void 0);
        _HistoryManager_history.set(this, []);
        __classPrivateFieldSet(this, _HistoryManager_drawingToolsManager, drawingToolsManager, "f");
        (0, viewer_1.addListener)(viewer_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, (e) => {
            const event = e;
            if (event.temporary === false && event.points !== undefined && event.fromHistory !== true && event.recordHistory !== false) {
                /**
                 * DO SOME CHECKS TO ENSURE THAT THE STATE IS CORRECT
                 */
                // 1. within number of points
                if (__classPrivateFieldGet(this, _HistoryManager_drawingToolsManager, "f").geometryState.checkNumberOfPoints(event.points.length) === false)
                    return;
                // 2. closed loop if it should be closed
                if (__classPrivateFieldGet(this, _HistoryManager_drawingToolsManager, "f").settings.geometry.close === true && __classPrivateFieldGet(this, _HistoryManager_drawingToolsManager, "f").geometryState.closeLoop === false && __classPrivateFieldGet(this, _HistoryManager_drawingToolsManager, "f").settings.geometry.autoClose === false)
                    return;
                this.recordState({
                    points: event.points
                });
            }
        });
    }
    // #endregion Constructors (1)
    // #region Public Methods (8)
    applyState(state) {
        __classPrivateFieldGet(this, _HistoryManager_drawingToolsManager, "f").geometryState.updateDataFromHistory(state.points);
    }
    canRedo() {
        return __classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f") < __classPrivateFieldGet(this, _HistoryManager_history, "f").length - 1;
    }
    canUndo() {
        return __classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f") > 0;
    }
    close() {
        __classPrivateFieldSet(this, _HistoryManager_currentStateIndex, -1, "f");
        __classPrivateFieldSet(this, _HistoryManager_history, [], "f");
    }
    getState() {
        return __classPrivateFieldGet(this, _HistoryManager_history, "f")[__classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f")];
    }
    recordState(state) {
        __classPrivateFieldSet(this, _HistoryManager_history, __classPrivateFieldGet(this, _HistoryManager_history, "f").slice(0, __classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f") + 1), "f");
        __classPrivateFieldGet(this, _HistoryManager_history, "f").push(state);
        __classPrivateFieldSet(this, _HistoryManager_currentStateIndex, __classPrivateFieldGet(this, _HistoryManager_history, "f").length - 1, "f");
    }
    redo() {
        var _a;
        if (!this.canRedo())
            return;
        if (__classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f") < __classPrivateFieldGet(this, _HistoryManager_history, "f").length - 1)
            __classPrivateFieldSet(this, _HistoryManager_currentStateIndex, (_a = __classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f"), _a++, _a), "f");
        this.applyState(__classPrivateFieldGet(this, _HistoryManager_history, "f")[__classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f")]);
    }
    undo() {
        var _a;
        if (!this.canUndo())
            return;
        if (__classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f") > 0)
            __classPrivateFieldSet(this, _HistoryManager_currentStateIndex, (_a = __classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f"), _a--, _a), "f");
        this.applyState(__classPrivateFieldGet(this, _HistoryManager_history, "f")[__classPrivateFieldGet(this, _HistoryManager_currentStateIndex, "f")]);
    }
}
exports.HistoryManager = HistoryManager;
_HistoryManager_currentStateIndex = new WeakMap(), _HistoryManager_drawingToolsManager = new WeakMap(), _HistoryManager_history = new WeakMap();
// #endregion Classes (1)
//# sourceMappingURL=HistoryManager.js.map